import { render, staticRenderFns } from "./EnrollmentsAdd.vue?vue&type=template&id=3cd04160"
import script from "./EnrollmentsAdd.vue?vue&type=script&lang=js"
export * from "./EnrollmentsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports